import styles from './SchoolList.styles';
import { Subscription } from '@/graphql/types';
import { BodySmallMidEmphasis } from '@/design-system';
import colors from '@/theme/colors';
import { useNavigate } from 'react-router-dom';
import { AccessibleDivButton } from '@/components';

interface SchoolListProps {
  schools: Array<Subscription>;
  otherSchoolsAmount: number;
}

export const SchoolList: React.FC<SchoolListProps> = ({ schools, otherSchoolsAmount }) => {
  const navigate = useNavigate();
  const onClick = (schoolId: string) => navigate(`/explore/all?audienceId=${schoolId}`);

  return (
    <div className={styles.container}>
      {schools &&
        schools.map(({ id, name }) => (
          <AccessibleDivButton
            className={styles.card}
            key={id}
            onClick={() => onClick(id)}
            role="link"
          >
            <BodySmallMidEmphasis className={styles.text} data-testid="schoolName">
              {name}
            </BodySmallMidEmphasis>
          </AccessibleDivButton>
        ))}
      {otherSchoolsAmount > 0 && (
        <BodySmallMidEmphasis color={colors.slate} data-testid="otherSchools">
          {`+ ${otherSchoolsAmount} other schools in the district`}
        </BodySmallMidEmphasis>
      )}
    </div>
  );
};
